import React from "react";
import { Container, Navbar, Logo } from "./components";

export const Header = () => {
  return (
    <header className="application-header">
      <Container>
        <Logo />
        <Navbar />
      </Container>
    </header>
  );
};

export default Header;
